import React, { useState, useEffect, useMemo, useRef } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import SearchIcon from "@mui/icons-material/Search";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import { useTranslation } from "react-i18next";
import { Alert, Snackbar, TextField, Select, MenuItem, FormControl, InputLabel, Box, Chip, Dialog, DialogTitle, DialogContent, DialogActions, Button, Tooltip, Typography, CircularProgress } from "@mui/material";

import Deletepopup from "../../pages/admin/Aresure";
import ClubUsersModal from "../../components/ClubUsersModal";
import PresenceReportDialog from "../../components/PresenceReportDialog";
import {
  generatefile,
  playeractive,
  uploadExcelOfUser,
  userdelete,
  getClubUsers,
  deleteClub,
  inviteClubAdmin,
  setDemoSourceClub,
} from "../../components/funtionsBD/Mainservice";

import Uploadfile from "../../pages/admin/Uploadfile";
import { allclublist } from "../../components/funtionsBD/Mainservice";
import AdminLayout from "../../components/AdminLayout";
import ClubLogoMark from "../../components/ClubLogoMark";
import DemoClubLookCard from "../../components/DemoClubLookCard";
import { usePermissions } from "../../context/Permissioncontext";
import { useBrand } from "../../context/BrandContext";
import { fetchClubBrandPreview } from "../../utils/fetchClubBrandPreview";
import { maybeAutoPromptAdminDigiping } from "../../utils/digipingClubSetup";
import { currentAppLanguage } from "../../utils/appLanguages";
import { executeClubSwitch, openSwitchClubDialog } from "../../utils/switchActiveClubClient";
import { CLUB_COUNTRIES } from "../../constants/countries";
import ImportClubFromWebsiteDialog from "./ImportClubFromWebsiteDialog";

const CLUB_PAGE_SIZE = 10;
const PRIORITY_COUNTRY_CODES = ["LU", "BE", "FR"];

export function Club() {
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [countryFilter, setCountryFilter] = useState("ALL");
  const [data, setdata] = useState();
  const [listLoading, setListLoading] = useState(false);
  const [pagination, setpagination] = useState({
    currentPage: 1,
    limit: CLUB_PAGE_SIZE,
    total: 0,
    totalPages: 0,
    nextPage: false,
  });
  const [id, setid] = useState(false);
  const [showdelete, setshowdelete] = useState(false);
  const [file, setfile] = useState(false);
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [err, seterror] = useState("");
  const [success, setsuccess] = useState("");
  const [showUsersModal, setShowUsersModal] = useState(false);
  const [selectedClub, setSelectedClub] = useState(null);
  const [showPresenceReport, setShowPresenceReport] = useState(false);
  const [presenceReportClub, setPresenceReportClub] = useState(null);
  const [showDeleteClub, setShowDeleteClub] = useState(false);
  const [clubToDelete, setClubToDelete] = useState(null);
  const [inviteClubTarget, setInviteClubTarget] = useState(null);
  const [inviteEmail, setInviteEmail] = useState("");
  const [inviteFirstName, setInviteFirstName] = useState("");
  const [inviteLastName, setInviteLastName] = useState("");
  const [inviteSending, setInviteSending] = useState(false);
  const [importOpen, setImportOpen] = useState(false);
  const { t, i18n } = useTranslation();
  const { hasPermission } = usePermissions();
  const { brand, applyBrandPreview, refreshBrand } = useBrand();
  const navigate = useNavigate();
  const location = useLocation();
  const listRequestId = useRef(0);

  const info = JSON.parse(localStorage.getItem("user"));
  const [effectiveClubId, setEffectiveClubId] = useState(info?.club_id || null);
  const [pendingOpenClubDialog, setPendingOpenClubDialog] = useState(
    Boolean(location.state?.openClubDialog)
  );
  const [pendingClubId, setPendingClubId] = useState(location.state?.clubId || null);

  const countryOptions = useMemo(() => {
    const priority = [];
    const rest = [];
    for (const c of CLUB_COUNTRIES) {
      if (PRIORITY_COUNTRY_CODES.includes(c.code)) priority.push(c);
      else rest.push(c);
    }
    priority.sort(
      (a, b) =>
        PRIORITY_COUNTRY_CODES.indexOf(a.code) -
        PRIORITY_COUNTRY_CODES.indexOf(b.code)
    );
    rest.sort((a, b) => a.name.localeCompare(b.name));
    return [...priority, ...rest];
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchQuery.trim());
    }, 300);
    return () => clearTimeout(timer);
  }, [searchQuery]);

  useEffect(() => {
    if (info?.type_user_id !== 2) return undefined;
    if (brand?.show_ai_coach === false) return undefined;
    const userId = info?.user_id;
    const clubId = info?.club_id || effectiveClubId;
    if (!userId || !clubId || !localStorage.getItem("token")) return undefined;

    let cancelled = false;
    (async () => {
      try {
        await maybeAutoPromptAdminDigiping({
          userId,
          clubId,
          t,
          lang: currentAppLanguage(i18n),
        });
      } catch (err) {
        if (!cancelled) console.warn("Club setup prompt failed:", err?.message || err);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [brand?.show_ai_coach, effectiveClubId, i18n, info?.club_id, info?.type_user_id, info?.user_id, t]);

  useEffect(() => {
    getuser(1, { replace: true });
  }, [debouncedSearch, countryFilter]);

  useEffect(() => {
    if (location.state?.openClubDialog) {
      setPendingOpenClubDialog(true);
      setPendingClubId(location.state.clubId || null);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state, location.pathname, navigate]);

  useEffect(() => {
    if (!pendingOpenClubDialog || !Array.isArray(data) || data.length === 0) return;

    const targetClubId = pendingClubId || info?.club_id || effectiveClubId;
    const clubToOpen =
      (targetClubId && data.find((c) => c.club_id === targetClubId || c.id === targetClubId)) ||
      (data.length === 1 ? data[0] : null);

    if (clubToOpen) {
      setSelectedClub(clubToOpen);
      setShowUsersModal(true);
    }
    setPendingOpenClubDialog(false);
    setPendingClubId(null);
  }, [pendingOpenClubDialog, data, effectiveClubId, info?.club_id, pendingClubId]);

  const getuser = async (page = 1, { replace = true, search, country } = {}) => {
    const requestId = ++listRequestId.current;
    try {
      setListLoading(true);
      const params = {
        search: search !== undefined ? search : debouncedSearch,
        country: country !== undefined ? country : countryFilter,
        page,
        limit: CLUB_PAGE_SIZE,
      };

      const response = await allclublist(params);
      if (requestId !== listRequestId.current) return;

      const rows = response.data.data || [];
      const pageInfo = response.data.pagination || {
        currentPage: page,
        limit: CLUB_PAGE_SIZE,
        total: rows.length,
        totalPages: 1,
        nextPage: false,
      };

      setdata((prev) => (replace || !Array.isArray(prev) ? rows : [...prev, ...rows]));
      setpagination(pageInfo);

      if (info?.type_user_id === 2 && !effectiveClubId && rows.length > 0) {
        const own =
          rows.find((c) => c.club_id === info?.club_id) ||
          (rows.length === 1 ? rows[0] : null);
        const clubId = own?.club_id || own?.id;
        if (clubId) {
          setEffectiveClubId(clubId);
        }
      }
    } catch (error) {
      if (requestId !== listRequestId.current) return;
      console.log(error);
    } finally {
      if (requestId === listRequestId.current) setListLoading(false);
    }
  };

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleCountryFilter = (event) => {
    setCountryFilter(event.target.value);
  };

  const clearFilters = () => {
    setSearchQuery("");
    setDebouncedSearch("");
    setCountryFilter("ALL");
  };

  const handleLoadMore = () => {
    if (!pagination.nextPage || listLoading) return;
    getuser((pagination.currentPage || 1) + 1, { replace: false });
  };

  const hasActiveFilters =
    Boolean(searchQuery.trim()) || countryFilter !== "ALL";
  const emptyMessage = hasActiveFilters
    ? t("noClubsFound")
    : t("noClubsYet");

  const handledelete = async () => {
    try {
      const params = {
        user_id: id,
      };
      const response = await userdelete(params);
      getuser(1, { replace: true });
      setshowdelete(false);
    } catch (error) {
      seterror(error.message);
      setOpen(true);
      if (error.code === 401) {
        localStorage.clear();
        navigate("/");
      }
      setshowdelete(false);
    }
  };
  const handlefile = async () => {
    try {
      const params = {};
      const response = await generatefile(params);
      const link = document.createElement("a");
      link.href = response.data.data;
      link.click();
    } catch (error) {
      seterror(error.message);
      setOpen(true);
      if (error.code === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };
  const handleupload = async (file) => {
    try {
      const params = new FormData();
      params.append("userFile", file);
      const response = await uploadExcelOfUser(params);
      setsuccess(response.data.message);
      setOpen(true);
    } catch (error) {
      seterror(error.error);
      setOpen2(true);
      if (error.code === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const onClose = () => {
    setshowdelete(false);
  };

  const handlePageChange = (pageNumber) => {
    getuser(pageNumber, { replace: true });
  };
  const handleinactive = async (id) => {
    try {
      const params = {
        player_id: id,
      };
      const response = await playeractive(params);
      setsuccess(response.data.message);
      setOpen(true);
      getuser(1, { replace: true });
    } catch (error) {
      seterror(error.message);
      setOpen2(true);
    }
  };

  const handleViewClubUsers = (club) => {
    setSelectedClub(club);
    setShowUsersModal(true);
  };

  const isSuperAdmin =
    info?.type_user_id === 1 || info?.isSuperAdmin === true;
  const isAdmin =
    Number(info?.type_user_id) === 2 || info?.hasAdminRole === true;
  const isCommittee =
    Number(info?.type_user_id) === 6 ||
    info?.hasCommitteeRole === true ||
    (Array.isArray(info?.all_role_names) &&
      info.all_role_names.includes("Committee Member"));
  const isCoach =
    Number(info?.type_user_id) === 3 || info?.hasCoachRole === true;
  const ownClubId = info?.club_id || effectiveClubId;
  const isOwnClub = (club) => {
    const cid = club?.club_id || club?.id;
    if (!cid) return false;
    if (ownClubId && cid === ownClubId) return true;
    // After API filter, every listed club is one this admin or coach manages.
    return !isSuperAdmin && (isAdmin || isCoach || isCommittee);
  };

  const [confirmSwitchClub, setConfirmSwitchClub] = useState(null);
  const [switchingActiveClub, setSwitchingActiveClub] = useState(false);

  const handlePromptSwitchClub = (club) => {
    const cid = club?.club_id || club?.id;
    const currentCid = effectiveClubId || info?.club_id;
    if (!cid || cid === currentCid) {
      openSwitchClubDialog();
      return;
    }
    setConfirmSwitchClub(club);
  };

  const handleConfirmSwitchClub = async () => {
    if (!confirmSwitchClub) return;
    const cid = confirmSwitchClub.club_id || confirmSwitchClub.id;
    setSwitchingActiveClub(true);
    try {
      await executeClubSwitch(cid, refreshBrand);
      if (isSuperAdmin && typeof applyBrandPreview === "function") {
        const resolved = await fetchClubBrandPreview(cid, confirmSwitchClub);
        applyBrandPreview(resolved);
      }
      setEffectiveClubId(cid);
      setsuccess(
        t("switchedToClub", "Switched to {{name}}. Active branding and data updated.", {
          name: confirmSwitchClub.club_name,
        })
      );
      setOpen(true);
      setConfirmSwitchClub(null);
      getuser(1, { replace: true });
    } catch (err) {
      seterror(err?.response?.data?.message || err?.message || "Failed to switch club");
      setOpen2(true);
    } finally {
      setSwitchingActiveClub(false);
    }
  };

  const canOpenPresenceReport =
    isSuperAdmin ||
    isAdmin ||
    isCoach ||
    isCommittee ||
    info?.type_user_id === 2 ||
    (Array.isArray(info?.all_role_names) &&
      info.all_role_names.some(
        (r) =>
          r === "Super Admin" ||
          r === "Admin" ||
          r === "Coach" ||
          r === "Expert Coach" ||
          r === "Committee Member"
      ));

  const listedClubs = Array.isArray(data) ? data : [];
  const isStaffSingleClub =
    !isSuperAdmin &&
    (isAdmin || isCoach || isCommittee) &&
    listedClubs.length === 1 &&
    !hasActiveFilters;

  useEffect(() => {
    if (isSuperAdmin) return;
    if (!(isAdmin || isCoach || isCommittee)) return;
    if (hasActiveFilters) return;
    if (!Array.isArray(data) || data.length !== 1) return;
    setSelectedClub((prev) => prev || data[0]);
    setShowUsersModal(true);
  }, [data, isSuperAdmin, isAdmin, isCoach, isCommittee, hasActiveFilters]);

  const handleOpenPresenceReport = (club) => {
    setPresenceReportClub(club);
    setShowPresenceReport(true);
  };

  const handleCloseUsersModal = () => {
    setShowUsersModal(false);
    if (isStaffSingleClub) {
      navigate("/Dashboard");
    }
  };

  const handleDeleteClub = (club) => {
    setClubToDelete(club);
    setShowDeleteClub(true);
  };

  const confirmDeleteClub = async () => {
    try {
      const response = await deleteClub(clubToDelete.club_id);
      setsuccess(response.data.message);
      setOpen(true);
      setShowDeleteClub(false);
      setClubToDelete(null);
      getuser(1, { replace: true }); // Refresh the club list
    } catch (error) {
      seterror(error.message);
      setOpen2(true);
      setShowDeleteClub(false);
      setClubToDelete(null);
    }
  };

  const handleStartClubDemo = async (club) => {
    try {
      await setDemoSourceClub(club.club_id);
      if (typeof applyBrandPreview === "function") {
        const resolved = await fetchClubBrandPreview(club.club_id, club);
        applyBrandPreview(resolved);
      }
      window.dispatchEvent(new CustomEvent("demo-source-club-changed", { detail: club }));
      setsuccess(
        t("demoActivatedForClub", {
          club: club.club_name,
          defaultValue: `Demo activated for ${club.club_name}! Brand and roster loaded.`,
        })
      );
      setOpen(true);
    } catch (error) {
      seterror(error?.message || t("demoLookSaveFailed", "Could not set demo club"));
      setOpen2(true);
    }
  };

  const cancelDeleteClub = () => {
    setShowDeleteClub(false);
    setClubToDelete(null);
  };

  const canInviteClubAdmin =
    isSuperAdmin ||
    info?.type_user_id === 2 ||
    (Array.isArray(info?.all_role_names) &&
      info.all_role_names.some((r) => r === "Super Admin" || r === "Admin"));

  const openInviteAdmin = (club) => {
    setInviteClubTarget(club);
    setInviteEmail("");
    setInviteFirstName("");
    setInviteLastName("");
  };

  const closeInviteAdmin = () => {
    if (inviteSending) return;
    setInviteClubTarget(null);
  };

  const submitInviteAdmin = async () => {
    if (!inviteClubTarget?.club_id || !inviteEmail.trim()) return;
    try {
      setInviteSending(true);
      const response = await inviteClubAdmin({
        email: inviteEmail.trim(),
        first_name: inviteFirstName.trim() || undefined,
        last_name: inviteLastName.trim() || undefined,
        club_id: inviteClubTarget.club_id,
      });
      setsuccess(response.message || t("inviteAdminSent") || "Club admin invitation sent");
      setOpen(true);
      setInviteClubTarget(null);
    } catch (error) {
      seterror(error.message || t("error_sending_invitation"));
      setOpen2(true);
    } finally {
      setInviteSending(false);
    }
  };
  
  return (
    <AdminLayout>
      <div className="title">
        <h1>{isSuperAdmin ? t("allclub") : t("myclub")}</h1>
      </div>

      <div>
        {isStaffSingleClub ? null : (
        <>
        <div className="filters">
          <div className="search-and-filters">
            {/* Search Bar */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1, flexWrap: "wrap" }}>
              {isSuperAdmin ? (
                <FormControl size="small" sx={{ minWidth: 160 }}>
                  <InputLabel>{t("country")}</InputLabel>
                  <Select
                    value={countryFilter}
                    onChange={handleCountryFilter}
                    label={t("country")}
                  >
                    <MenuItem value="ALL">{t("allCountries")}</MenuItem>
                    {countryOptions.map((country) => (
                      <MenuItem key={country.code} value={country.code}>
                        {country.code} — {country.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              ) : null}

              <TextField
                size="small"
                placeholder={
                  isSuperAdmin
                    ? t("searchClubsByName", "Type club name or code…")
                    : t("searchClubs")
                }
                value={searchQuery}
                onChange={handleSearch}
                InputProps={{
                  startAdornment: <SearchIcon sx={{ color: 'action.active', mr: 1 }} />
                }}
                sx={{ minWidth: 250, flex: 1 }}
              />

              {/* Clear Filters Button */}
              {hasActiveFilters && (
                <Chip
                  label={t("clearFilters")}
                  onClick={clearFilters}
                  onDelete={clearFilters}
                  color="primary"
                  variant="outlined"
                  size="small"
                />
              )}
            </Box>
          </div>

          {hasPermission("CREATE_CLUB") && (
            <div className="filtersandbutton">
              <NavLink to="/AddClub" className="adduser">
                {t("addnewclub")}
              </NavLink>
              {isSuperAdmin ? (
                <button
                  type="button"
                  className="adduser import-club-web"
                  onClick={() => setImportOpen(true)}
                >
                  {t("importClubFromWebsite")}
                </button>
              ) : null}
            </div>
          )}
        </div>
        {isSuperAdmin && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5, mt: -0.5 }}>
            {t(
              "superAdminClubSearchHint",
              "Showing the 10 most recent clubs. Pick a country and type a club name to find one among thousands."
            )}
            {pagination.total > 0
              ? ` ${t("showingClubsCount", "Showing {{shown}} of {{total}}.", {
                  shown: data?.length || 0,
                  total: pagination.total,
                })}`
              : ""}
          </Typography>
        )}
        {isSuperAdmin && <DemoClubLookCard />}
        </>
        )}
        {listLoading && !data?.length ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress size={28} />
          </Box>
        ) : isStaffSingleClub ? null : data?.length > 0 ? (
          <>
            <div className="data_table_over">
              <table className="data_table">
                <thead>
                  <tr>
                    <th>{t("name")}</th>
                    <th>{t("country")}</th>
                    <th>{t("create")}</th>
                    <th>{t("mail")}</th>
                    <th>{t("action")}</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr 
                      key={`club-${item.club_id || item.id || "row"}-${index}`} 
                      className="data_table_row"
                      style={{ 
                        cursor: isSuperAdmin || isOwnClub(item) ? "pointer" : "default",
                      }}
                      onClick={() => {
                        if (isSuperAdmin || isOwnClub(item)) {
                          const currentClubId = effectiveClubId || info?.club_id;
                          const targetId = item.club_id || item.id;
                          if (isCoach && !isAdmin && !isSuperAdmin && currentClubId !== targetId) {
                            handlePromptSwitchClub(item);
                            return;
                          }
                          handleViewClubUsers(item);
                        }
                      }}
                    >
                      <td>
                        <div className="user_name">
                          <Box
                            component="span"
                            onClick={(e) => {
                              e.stopPropagation();
                              handlePromptSwitchClub(item);
                            }}
                            sx={{ display: "inline-flex", cursor: "pointer" }}
                            title={t("switchClubPrompt", "Switch club")}
                          >
                            <ClubLogoMark
                              club={item}
                              useBrandFallback={
                                (effectiveClubId || info?.club_id) === item.club_id
                              }
                              size="sm"
                            />
                          </Box>
                          {item.club_name}
                          {(effectiveClubId || info?.club_id) === (item.club_id || item.id) ? (
                            <Chip
                              icon={<CheckCircleIcon sx={{ fontSize: "14px !important" }} />}
                              label={t("activeClub", "Active")}
                              size="small"
                              color="success"
                              sx={{ ml: 1, height: 20, fontSize: "0.65rem", fontWeight: 600 }}
                            />
                          ) : null}
                          {item.is_demo ? (
                            <Chip
                              label={t("demoLookKicker", "Demo session")}
                              size="small"
                              color="primary"
                              sx={{ ml: 1, height: 20, fontSize: "0.65rem" }}
                            />
                          ) : null}
                          <Chip
                            label={`${(item.license_tier || "base").toUpperCase()}${item.addon_hr ? " + HR" : ""}`}
                            size="small"
                            variant="outlined"
                            sx={{
                              ml: 1,
                              height: 20,
                              fontSize: "0.65rem",
                              fontWeight: 700,
                              borderColor:
                                (item.license_tier || "base") === "pro"
                                  ? "#9333ea"
                                  : (item.license_tier || "base") === "plus"
                                  ? "#10b981"
                                  : "#3b82f6",
                              color:
                                (item.license_tier || "base") === "pro"
                                  ? "#7e22ce"
                                  : (item.license_tier || "base") === "plus"
                                  ? "#047857"
                                  : "#1d4ed8",
                              backgroundColor:
                                (item.license_tier || "base") === "pro"
                                  ? "#faf5ff"
                                  : (item.license_tier || "base") === "plus"
                                  ? "#ecfdf5"
                                  : "#eff6ff",
                            }}
                          />
                        </div>
                      </td>
                      <td>
                        <Chip 
                          label={item.country || 'N/A'} 
                          size="small" 
                          color={item.country === 'LU' ? 'primary' : 'default'}
                          variant="outlined"
                        />
                      </td>
                      <td>{item.createdAt.split("T")[0]}</td>

                      <td style={{ textTransform: "lowercase" }}>
                        {item.club_email}
                      </td>
                      <td>
                        <div style={{ 
                          display: 'flex', 
                          gap: '8px', 
                          alignItems: 'center',
                          width: canOpenPresenceReport || canInviteClubAdmin ? "260px" : "190px"
                        }}>
                          {!isSuperAdmin && (isAdmin || isCoach) && (effectiveClubId || info?.club_id) !== (item.club_id || item.id) && (
                            <Button
                              size="small"
                              variant="outlined"
                              startIcon={<SwapHorizIcon sx={{ fontSize: "16px !important" }} />}
                              onClick={(e) => {
                                e.stopPropagation();
                                handlePromptSwitchClub(item);
                              }}
                              sx={{
                                textTransform: "none",
                                fontSize: "0.75rem",
                                height: 26,
                                borderRadius: "13px",
                                borderColor: "var(--brand-primary, #0877bc)",
                                color: "var(--brand-primary, #0877bc)",
                                "&:hover": {
                                  borderColor: "var(--brand-primary, #0877bc)",
                                  backgroundColor: "rgba(8, 119, 188, 0.08)",
                                },
                              }}
                            >
                              {t("select", "Select")}
                            </Button>
                          )}
                          {isSuperAdmin && !item.is_demo && (
                            <Tooltip title={t("demoThisClub", "Start demo with this club")}>
                              <PlayCircleOutlineIcon
                                sx={{
                                  color: "var(--brand-primary, #0877bc)",
                                  cursor: "pointer",
                                  fontSize: "20px",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleStartClubDemo(item);
                                }}
                              />
                            </Tooltip>
                          )}
                          {(isSuperAdmin || isOwnClub(item)) && (
                            <VisibilityIcon
                              sx={{ 
                                color: "var(--blue)", 
                                cursor: "pointer",
                                fontSize: "20px"
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                const currentClubId = effectiveClubId || info?.club_id;
                                const targetId = item.club_id || item.id;
                                if (isCoach && !isAdmin && !isSuperAdmin && currentClubId !== targetId) {
                                  handlePromptSwitchClub(item);
                                  return;
                                }
                                handleViewClubUsers(item);
                              }}
                              title={t("viewUsers")}
                            />
                          )}
                          {canOpenPresenceReport && (isSuperAdmin || isOwnClub(item)) && (
                            <HowToRegIcon
                              sx={{
                                color: "var(--brand-primary, #0d9488)",
                                cursor: "pointer",
                                fontSize: "20px",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleOpenPresenceReport(item);
                              }}
                              title={t("presenceReportOpen")}
                            />
                          )}
                          {canInviteClubAdmin && (isSuperAdmin || isOwnClub(item)) && (
                            <PersonAddIcon
                              sx={{
                                color: "var(--brand-primary, #0877bc)",
                                cursor: "pointer",
                                fontSize: "20px",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                openInviteAdmin(item);
                              }}
                              title={t("inviteClubAdmin") || "Invite club admin"}
                            />
                          )}
                          {/* Show edit button for Super Admins with permission OR for club admins (type_user_id === 2) on their own clubs */}
                          {/* Coaches (type_user_id === 3) cannot edit club info, even if they have UPDATE_CLUB_INFO permission */}
                          {((info?.isSuperAdmin || info?.type_user_id === 1) && hasPermission("UPDATE_CLUB_INFO")) || (info?.type_user_id === 2 && isOwnClub(item)) ? (
                            <EditIcon
                              sx={{ 
                                color: "var(--black)", 
                                cursor: "pointer",
                                fontSize: "20px"
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                navigate("/EditClub", {
                                  state: {
                                    info: item,
                                  },
                                });
                              }}
                              title={t("editClub")}
                            />
                          ) : null}
                          {hasPermission("DELETE_CLUB") && (
                            <DeleteIcon
                              sx={{ 
                                color: "var(--red)", 
                                cursor: "pointer",
                                fontSize: "20px"
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDeleteClub(item);
                              }}
                              title={t("deleteClub")}
                            />
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {isSuperAdmin && pagination.nextPage ? (
              <Box sx={{ display: "flex", justifyContent: "center", mt: 2, mb: 1 }}>
                <Button
                  variant="outlined"
                  onClick={handleLoadMore}
                  disabled={listLoading}
                  startIcon={listLoading ? <CircularProgress size={16} /> : null}
                >
                  {t("loadMoreClubs", "Load more clubs")}
                </Button>
              </Box>
            ) : null}
          </>
        ) : (
          <p className="nodata">{emptyMessage}</p>
        )}

        <Uploadfile
          isOpen={file}
          setisOpen={setfile}
          handleupload={handleupload}
        />
        <Deletepopup
          isOpen={showdelete}
          setisOpen={setshowdelete}
          handledelete={handledelete}
          onClose={onClose}
        />

        {/* Club Users Modal */}
        <ClubUsersModal
          isOpen={showUsersModal}
          onClose={handleCloseUsersModal}
          fitScreen={isStaffSingleClub}
          canOpenPresence={canOpenPresenceReport && Boolean(selectedClub)}
          onOpenPresence={() => handleOpenPresenceReport(selectedClub)}
          clubId={selectedClub?.club_id}
          clubName={selectedClub?.club_name}
          clubImage={selectedClub?.club_image}
          clubData={selectedClub}
          onClubUpdated={(updated) => {
            setSelectedClub((prev) => (prev ? { ...prev, ...updated } : updated));
            setdata((prev) =>
              Array.isArray(prev)
                ? prev.map((club) =>
                    club.club_id === updated.club_id ? { ...club, ...updated } : club
                  )
                : prev
            );
          }}
        />

        <PresenceReportDialog
          open={showPresenceReport}
          onClose={() => {
            setShowPresenceReport(false);
            setPresenceReportClub(null);
          }}
          clubId={presenceReportClub?.club_id}
          clubName={presenceReportClub?.club_name}
        />

        {/* Delete Club Confirmation Modal */}
        <Deletepopup
          isOpen={showDeleteClub}
          setisOpen={setShowDeleteClub}
          handledelete={confirmDeleteClub}
          onClose={cancelDeleteClub}
        />

        {/* Switch Club Confirmation Dialog */}
        <Dialog
          open={Boolean(confirmSwitchClub)}
          onClose={() => !switchingActiveClub && setConfirmSwitchClub(null)}
          maxWidth="xs"
          fullWidth
          PaperProps={{ sx: { borderRadius: 3, p: 1 } }}
        >
          <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1.5, pb: 1 }}>
            <SwapHorizIcon sx={{ color: "var(--brand-primary, #0877bc)", fontSize: 28 }} />
            <Box>
              <Typography variant="h6" component="div" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
                {t("switchClubTitle", "Switch Club")}
              </Typography>
            </Box>
          </DialogTitle>
          <DialogContent>
            <Typography variant="body1" sx={{ color: "text.secondary", mt: 1 }}>
              {t(
                "switchClubConfirmPrompt",
                "Do you want to switch to {{clubName}}? This will update your active club branding and club data.",
                { clubName: confirmSwitchClub?.club_name || "Club" }
              )}
            </Typography>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2, pt: 1 }}>
            <Button
              onClick={() => setConfirmSwitchClub(null)}
              disabled={switchingActiveClub}
              sx={{ textTransform: "none" }}
            >
              {t("cancel", "Cancel")}
            </Button>
            <Button
              variant="contained"
              onClick={handleConfirmSwitchClub}
              disabled={switchingActiveClub}
              sx={{
                textTransform: "none",
                borderRadius: 2,
                backgroundColor: "var(--brand-primary, #0877bc)",
                "&:hover": {
                  backgroundColor: "var(--brand-primary-hover, #065b8f)",
                },
              }}
            >
              {switchingActiveClub ? (
                <CircularProgress size={18} color="inherit" />
              ) : (
                t("switch", "Switch")
              )}
            </Button>
          </DialogActions>
        </Dialog>

        <Snackbar
          open={open}
          autoHideDuration={3000}
          onClose={() => setOpen(false)}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
        >
          <Alert variant="filled">{success}</Alert>
        </Snackbar>
        <Snackbar
          open={open2}
          autoHideDuration={3000}
          onClose={() => setOpen2(false)}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
        >
          <Alert variant="filled" severity="error">
            {err}
          </Alert>
        </Snackbar>

        <ImportClubFromWebsiteDialog
          open={importOpen}
          onClose={() => setImportOpen(false)}
          onCreated={() => {
            setCountryFilter("ALL");
            setSearchQuery("");
            setDebouncedSearch("");
            getuser(1, { replace: true, search: "", country: "ALL" });
          }}
        />

        <Dialog open={Boolean(inviteClubTarget)} onClose={closeInviteAdmin} fullWidth maxWidth="sm">
          <DialogTitle>
            {t("inviteClubAdmin") || "Invite club admin"}
            {inviteClubTarget?.club_name ? ` — ${inviteClubTarget.club_name}` : ""}
          </DialogTitle>
          <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 1 }}>
            <p style={{ margin: "8px 0 0", color: "#555" }}>
              {t("inviteAdminEmailHint") ||
                "They will receive a link to register as administrator of this club."}
            </p>
            <TextField
              autoFocus
              label={t("mail")}
              type="email"
              value={inviteEmail}
              onChange={(e) => setInviteEmail(e.target.value)}
              required
              fullWidth
            />
            <TextField
              label={t("firstname") || "First name"}
              value={inviteFirstName}
              onChange={(e) => setInviteFirstName(e.target.value)}
              fullWidth
            />
            <TextField
              label={t("lastname") || "Last name"}
              value={inviteLastName}
              onChange={(e) => setInviteLastName(e.target.value)}
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={closeInviteAdmin} disabled={inviteSending}>
              {t("cancel") || "Cancel"}
            </Button>
            <Button
              onClick={submitInviteAdmin}
              disabled={inviteSending || !inviteEmail.trim()}
              variant="contained"
            >
              {inviteSending ? (t("sending") || "Sending…") : (t("sendinvite") || "Send invite")}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </AdminLayout>
  );
}
